module.exports = __webpack_public_path__ + "static/14-3-c41aa5df71a4d5b33eaa9c7b1bc91e4e.jpg";